import VODSection from './VODSection';

export default VODSection;
